<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text class="pa-0">
          <v-container class="pb-0">
            <v-row class="ma-0">
              <v-col cols="6" class="pa-0">
                <v-row class="ma-0">
                  <v-col cols="6" class="pa-0">
                    <v-select
                      ref="type"
                      :items="$ACTIONS"
                      label="種別"
                      v-model="tempItem.type"
                      item-text="name"
                      item-value="key"
                      @change="onChangeType()"
                      :disabled="type == 'view'"
                    ></v-select>
                  </v-col>
                  <template v-if="tempItem.type == 4">
                    <v-col cols="6" class="py-0">
                      <v-select
                        ref="tygs"
                        :items="$YCSS"
                        label="YCS"
                        v-model="tempItem.tyg"
                        :rules="[rules.required]"
                        item-text="name"
                        item-value="key"
                      ></v-select>
                    </v-col>
                  </template>
                  <template v-else-if="tempItem.type == 1 || tempItem.type == 2 || tempItem.type == 3 || tempItem.type === 5 || tempItem.type == 6">
                    <v-col cols="6" class="py-0">
                      <template-date-picker
                        :id="1"
                        :date="tempItem.date1"
                        :label="'日付'"
                        :title="false"
                        @updated="onUpdated"
                        :validate="validate"
                      ></template-date-picker>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
                <template-memo
                  :label="tempItem.type == 6 ? (extension == 1 ? '退会理由' : '退塾理由') : 'メモ'"
                  :event="tempItem"
                  :rules="tempItem.type == 6 ? [rules.required] : []"
                  :attach="true"
                  :files="files"
                  :type="type"
                  @update="onUpdateMemo"
                >
                </template-memo>
              </v-col>
              <v-col cols="12">
                <template v-if="user.status != $STATUS_LOSE">
                  <v-layout row align-center>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="tempItem && tempItem.type == null" rounded depressed class="mr-0" color="error" @click="onSubmitDialog()">登録</v-btn>
                  </v-layout>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='登録'
        :message="getTypeName() +  ' を登録します。よろしいですか?'"
        :dialog='dialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='日付'
        :message="extension == 1 ? '退会日は入会日の前に指定できません' : '退塾日は入塾日の前に指定できません'"
        :dialog='dateErrorDialog'
        color="error"
        :cancel='false'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import * as async from 'async'
import DatePicker from '../common/TemplateDate.vue'
Vue.component('template-date-picker', DatePicker)
export default {
  computed: {
    ...mapGetters({
      extension: 'shared/extension'
    })
  },
  data () {
    return {
      dialog: false,
      dateErrorDialog: false,
      loading: false,
      tempItem: null,
      menu: false,
      menu1: false,
      formHasErrors: false,
      validate: false,
      files: [],
      rules: {
        required: value => !!value || 'Required.',
        graduation: value => !!value || 'Required.'
      },
      action: 'N/A',
      tyg: 1
    }
  },
  props: [ 'user', 'item', 'type' ],
  watch: {
    item () {
      this.tempItem = JSON.parse(JSON.stringify(this.item))
    }
  },
  created () {
    this.tempItem = JSON.parse(JSON.stringify(this.item))
  },
  methods: {
    onChangeType () {
      if (this.tempItem.type === 1 || this.tempItem.type === 2 || this.tempItem.type === 3 || this.tempItem.type === 5 || this.tempItem.type === 6) {
        if (this.tempItem.date1 === null) {
          moment.tz.setDefault('Asia/Tokyo')
          this.tempItem.date1 = moment(new Date()).format('YYYY-MM-DD')
        }
      } else {
        this.tempItem.date1 = null
      }
    },
    getTypeName () {
      var index = this.$ACTIONS.findIndex(a => a.key === this.tempItem.type)
      if (index !== -1) {
        return this.$ACTIONS[index].name
      }
      return ''
    },
    onUpdateMemo: function (value) {
      this.tempItem.memo = value.item.memo
      this.tempItem.attaches = value.item.attaches
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 1:
          this.tempItem.date1 = value.date
          break
      }
    },
    onDismissed: function (value) {
      if (this.dateErrorDialog) {
        this.dateErrorDialog = false
        return
      }
      if (this.dialog) {
        this.dialog = false
        if (value) {
          this.onSubmit()
        }
      }
    },
    onSubmitDialog () {
      this.formHasErrors = false
      if (this.tempItem.type === null) {
        this.$refs.type.validate(true)
        this.formHasErrors = true
      }
      if (this.tempItem.type === 1 || this.tempItem.type === 2 || this.tempItem.type === 3 || this.tempItem.type === 5 || this.tempItem.type === 6) {
        if (!this.tempItem.date1) {
          this.validate = true
          this.formHasErrors = true
        }
      }
      if (this.tempItem.type === 6) {
        moment.tz.setDefault('Asia/Tokyo')
        var from = moment(this.user.admission)
        var to = moment(this.tempItem.date1)
        if (from.diff(to) > 0) {
          this.dateErrorDialog = true
          this.formHasErrors = true
        }
      }
      if (this.tempItem.type === 4) {
        if (!this.tempItem.tyg) {
          this.$refs.tygs.validate(true)
          this.formHasErrors = true
        }
      }
      if (!this.formHasErrors) {
        this.dialog = true
      }
    },
    fwrite (file) {
      var vm = this
      return new Promise((resolve) => {
        vm.$store.dispatch('storage/write', { blob: file.blob, child: 'students', id: vm.user.key, uuid: vm.genUUIDv4() }).then(function (resp) {
          resolve(resp)
        })
      })
    },
    storeFiles () {
      var vm = this
      this.loading = true
      return new Promise((resolve) => {
        async.eachSeries(this.files, function (file, cb) {
          vm.fwrite(file).then(function (resp) {
            if (resp) {
              var payload = vm.tempItem.attaches ? JSON.parse(JSON.stringify(vm.tempItem.attaches)) : []
              payload.push({
                name: file.name,
                mime: file.mime,
                size: file.size,
                path: resp.path,
                thumbnail: resp.thumbnail
              })
              vm.tempItem.attaches = payload
            }
            cb()
          })
        }, function (error) {
          if (error) {
          }
          vm.loading = false
          resolve()
        })
      })
    },
    onSubmit () {
      var vm = this
      this.dialog = false
      this.storeFiles().then(function () {
        vm.files = []
        vm.$emit('submitEvent', vm.tempItem)
      })
    }
  }
}
</script>
